import { Home } from './Home';
import { AdminApp } from './admin/AdminApp';

/**
 * Minimal path routing — no router dependency. The front page is everything;
 * /admin is the hidden magic-link console. Cloudflare Pages serves index.html
 * for both (SPA fallback via public/_redirects), and this branch decides.
 */
export function App() {
  const path = typeof window !== 'undefined' ? window.location.pathname : '/';
  if (path === '/admin' || path.startsWith('/admin/')) return <AdminApp />;
  // Unknown route (e.g. /admon, /cheese) → reroute to the home page. The SPA
  // fallback already served index.html at the weird URL, so rewrite the bar to
  // "/" (no reload, no flash) before rendering Home.
  if (path !== '/' && typeof window !== 'undefined') {
    window.history.replaceState(null, '', '/');
  }
  return <Home />;
}
